/* Goorello — scroll reveal + count-up.
   Deliberately dependency-free: an IntersectionObserver costs ~1KB versus ~70KB
   for an animation library, and this page's LCP is a revenue number. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    document.querySelectorAll('.g-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  if (reduced || !('IntersectionObserver' in window)) {
    revealAll();
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    var observe = function () {
      document.querySelectorAll('.g-reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
    };
    observe();
    document.addEventListener('shopify:section:load', observe);

    /* Belt and braces #1: reveal anything near the fold if the observer is slow. */
    setTimeout(function () {
      var above = window.innerHeight * 1.2;
      document.querySelectorAll('.g-reveal:not(.is-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < above) el.classList.add('is-in');
      });
    }, 1200);

    /* Belt and braces #2 — the important one.
       Some environments (embedded webviews, screenshot/prerender engines) never
       tick CSS transitions, so an element can hold .is-in and still compute to
       opacity 0 forever. Detect that exact stuck state and drop out of animated
       mode entirely, which falls back to the plain visible base rule. */
    window.addEventListener('load', function () {
      setTimeout(function () {
        var marked = document.querySelectorAll('.g-reveal.is-in');
        if (!marked.length) { document.documentElement.classList.remove('g-anim'); return; }
        var stuck = 0, checked = Math.min(marked.length, 5);
        for (var i = 0; i < checked; i++) {
          if (parseFloat(getComputedStyle(marked[i]).opacity) < 0.9) stuck++;
        }
        if (stuck === checked) {
          /* Transitions are not running in this environment. Drop out of
             animated mode AND hard-set the final state inline, because an
             in-flight transition can otherwise stay frozen at opacity 0. */
          document.documentElement.classList.remove('g-anim');
          document.querySelectorAll('.g-reveal').forEach(function (el) {
            el.style.transition = 'none';
            el.style.opacity = '1';
            el.style.transform = 'none';
          });
        }
        revealAll();
      }, 1800);
    });
  }

  /* Count-up for [data-count] — runs once, respects reduced motion */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
    var suffix = el.getAttribute('data-suffix') || '';
    if (isNaN(target)) return;
    if (reduced) { el.textContent = target.toFixed(dec) + suffix; return; }
    var dur = 1100, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(dec) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-count]').forEach(function (el) { cio.observe(el); });

    /* Same failsafe as the reveal: a stat stuck on "0" is worse than no
       animation at all, so force the final value if nothing has fired. */
    window.addEventListener('load', function () {
      setTimeout(function () {
        document.querySelectorAll('[data-count]').forEach(function (el) {
          if (el.textContent.trim() === '0' || el.textContent.trim() === '') {
            var t = parseFloat(el.getAttribute('data-count'));
            var d = parseInt(el.getAttribute('data-decimals') || '0', 10);
            if (!isNaN(t)) el.textContent = t.toFixed(d) + (el.getAttribute('data-suffix') || '');
          }
        });
      }, 2500);
    });
  } else {
    document.querySelectorAll('[data-count]').forEach(countUp);
  }

  /* FAQ accordion */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.g-faq__q');
    if (!btn) return;
    var item = btn.parentElement;
    var open = item.classList.contains('is-open');
    var root = btn.closest('.g-faq');
    if (root) root.querySelectorAll('.g-faq__item.is-open').forEach(function (i) {
      i.classList.remove('is-open');
      var b = i.querySelector('.g-faq__q'); if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!open) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
  });
})();
